if (!customElements.get('redseven-paypal-message')) {
  customElements.define('redseven-paypal-message', class extends HTMLElement {
    connectedCallback() {
      this.unitPrice = Number(this.dataset.unitPrice);
      this.onVariant = (event) => {
        const form = document.getElementById(this.dataset.formId);
        if (!form || !event.target.contains(form) || !event.detail?.variant) return;
        this.unitPrice = Number(event.detail.variant.price);
        this.updateAmount();
      };
      this.onQuantity = (event) => {
        if (event.target.name === 'quantity' && event.target.form?.getAttribute('id') === this.dataset.formId) this.updateAmount();
      };
      document.addEventListener('variant:change', this.onVariant, true);
      document.addEventListener('change', this.onQuantity, true);
      document.addEventListener('input', this.onQuantity, true);
      this.updateAmount();
    }
    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariant, true);
      document.removeEventListener('change', this.onQuantity, true);
      document.removeEventListener('input', this.onQuantity, true);
    }
    updateAmount() {
      const form = document.getElementById(this.dataset.formId);
      const quantity = Number(form?.elements.namedItem('quantity')?.value || 1);
      const amount = this.unitPrice * quantity / 100;
      if (Number.isFinite(amount) && amount > 0) this.querySelector('[data-pp-message]').setAttribute('data-pp-amount', amount.toFixed(2));
    }
  });
}
